// extracted by mini-css-extract-plugin
export default {"main_title":"style_main_title__gpixs"};